import React from 'react';
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './MobileDeleteButton.module.scss';

interface MobileDeleteButtonProps {
    onClick: () => void;
    title?: string;
}

export const MobileDeleteButton: React.FC<MobileDeleteButtonProps> = ({ onClick, title = 'Delete' }) => {
    return (
        <button
            type="button"
            className={styles.button}
            onClick={onClick}
            title={title}
        >
            <FontAwesomeIcon
                icon={faTrashCan}
                className={styles.icon}
            />
            <span className={styles.text}>Delete</span>
        </button>
    );
};
